import { motion } from "framer-motion";

/**
 * Empty-state главного чата: стандартное приветствие от AICORES IDE.
 * Просто встречаем заголовком — без галереи примеров.
 */
export function Welcome() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="max-w-3xl mx-auto px-1 py-6 sm:py-10"
    >
      <div className="text-center space-y-3">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
          className="mx-auto inline-flex items-center gap-2 rounded-full border border-border/50 bg-bg-card/70 backdrop-blur px-2.5 py-0.5 text-[10px] uppercase tracking-wider text-fg-subtle font-mono"
        >
          <span className="size-1.5 rounded-full bg-success animate-pulse-soft" />
          AICORES IDE · готов к работе
        </motion.div>
        <h1 className="text-h1 sm:text-display text-balance">
          <span className="grad-text">Что сделаем сегодня?</span>
        </h1>
        <p className="text-fg-muted max-w-lg mx-auto text-pretty text-small">
          Опишите задачу — агент составит план и выполнит шаги.
        </p>
      </div>
    </motion.div>
  );
}
